import Parseable from '@/misc/Parseable';
import Promoter from '@/models/Promoter';
import Phone from '@/interfaces/phone.interface';

export default class Driver extends Parseable {
    public id!: string;
    public serialId!: string;
    public firstName!: string;
    public lastName!: string;
    public phone!: Phone;
    public driverLicense!: string;
    public isVerified!: boolean;
    public status!: boolean;
    public active!: boolean;
    public submittedDocuments!: boolean;
    public credit!: number;
    public numberOfRides!: number;
    public passengerCount!: number;
    public transactionAmount!: number;
    public promoter?: string | Promoter;
    public avatar?: string | null;
    // Block metadata (see backend MODERATION.md). blockedAt != null is the
    // block marker; `active: false` alone also means "never activated".
    // Safe to carry through parseToObject: backend driver.update picks its
    // fields explicitly, so these never write back through an edit.
    public blockedAt?: string | null;
    public blockReason?: string | null;

    public static parseFromObject(object: Partial<Driver>): Driver {
        const driver = new Driver();
        Object.assign(driver, object);

        return driver;
    }

    public parseToObject(): Partial<Driver> {
        const tmp = { ...this };
        return tmp;
    }
}
